var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8898 10.3033C21.0162 9.4554 20.9747 8.58735 20.7654 7.7527C20.489 6.6501 19.9196 5.6059 19.0573 4.74365C18.1951 3.88141 17.1509 3.31205 16.0483 3.03558C15.2137 2.82629 14.3456 2.78484 13.4977 2.91123",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0948 9.90173C17.2302 8.99343 16.9483 8.03493 16.2491 7.33573C15.5498 6.63653 14.5913 6.35458 13.6831 6.48998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18775 4.39709C7.55105 4.39709 7.88575 4.5941 8.06205 4.91172L9.2853 7.11513C9.44545 7.40363 9.45295 7.75258 9.3054 8.04773L8.127 10.4045C8.127 10.4045 8.4685 12.1603 9.8977 13.5895C11.3269 15.0187 13.0767 15.3543 13.0767 15.3543L15.4332 14.1761C15.7285 14.0284 16.0777 14.036 16.3663 14.1965L18.576 15.425C18.8933 15.6014 19.0901 15.9359 19.0901 16.299V18.8357C19.0901 20.1276 17.8901 21.0606 16.6661 20.6476C14.1521 19.7993 10.2498 18.1842 7.7764 15.7108C5.30295 13.2374 3.68785 9.33503 2.83958 6.82108C2.42657 5.59703 3.35961 4.39709 4.65144 4.39709H7.18775Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.280ab35a10c73d4f6b5f1292fa1ecbda.svg";
export { ForwardRef as ReactComponent };